import PrimarySourceIcon from "@/components/icons/PrimarySourceIcon";
import LinkOrSpan from "@/components/links/LinkOrSpan/LinkOrSpan";
import styles from "./PrimarySourceTag.module.scss";

export default function PrimarySourceTag({ num, to }: { num?: number; to?: string }) {
  return (
    <LinkOrSpan
      to={to}
      className={[styles.PrimarySourceTag, styles.link].join(" ")}
    >
      <PrimarySourceIcon />
      <span>Source{num && ` to ${num} proxies`}</span>
    </LinkOrSpan>
  );
}
